import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {CurrentUserAdapter} from '@drl/core/auth/adapters/current-user-adapter.service';
import * as moment from 'moment';

import {ChatMessage} from '../models/chat-message.model';

@Injectable()
export class ChatMessageAdapter implements IAdapter<ChatMessage> {
  constructor(private readonly userAdapter: CurrentUserAdapter) {}

  adaptToModel(resp: any): ChatMessage {
    const message: ChatMessage = new ChatMessage();
    Object.assign(message, resp);
    if (resp.sender) {
      message.sender = this.userAdapter.adaptToModel(resp.sender);
      message.displayTitle = `${message.sender.fullName}, ${moment(
        message.createdOn,
      ).format('D MMM')}`;
    }
    if (resp.parent) {
      message.parent = this.adaptToModel(resp.parent);
    }

    return message;
  }
  adaptFromModel(data: ChatMessage): any {
    const dataToSend = Object.assign({}, data);
    delete dataToSend.sender;
    delete dataToSend.displayTitle;
    return data;
  }
}
